<template>
    <div class="date-picker-box">
      <!-- 日历图标 -->
      
      <el-dropdown>
            <span class="el-dropdown-link">
                <i class="el-icon-date"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item></el-dropdown-item>
                <el-dropdown-item>狮子头</el-dropdown-item>
                <el-dropdown-item>螺蛳粉</el-dropdown-item>
                <el-dropdown-item disabled>双皮奶</el-dropdown-item>
                <el-dropdown-item divided>蚵仔煎</el-dropdown-item>
            </el-dropdown-menu>
      </el-dropdown>
      <!-- 开始时间 -->
      <el-date-picker
        v-model="start"
        type="date"
        placeholder="开始日期"
        style="width: 160px;"
        @change="emitValue"
      />
      <span style="margin: 0 8px;">至</span>
      <!-- 结束时间 -->
      <el-date-picker
        v-model="end"
        type="date"
        placeholder="结束日期"
        style="width: 160px;"
        @change="emitValue"
      />
    </div>
  </template>
  
  <script>
  export default {
    name: "DateRangePicker",
    props: {
      value: {
        type: Array, // [开始时间, 结束时间]
        default: () => []
      }
    },
    data() {
      return {
        start: this.value[0] || null,
        end: this.value[1] || null
      };
    },
    watch: {
      value(val) {
        this.start = val[0] || null;
        this.end = val[1] || null;
      }
    },
    methods: {
      emitValue() {
        const range = [this.start, this.end];
        this.$emit("input", range);  // v-model 双向绑定
        this.$emit("change", range); // change 事件
      }
    }
  };
  </script>
  
  <style scoped lang="scss">
  .date-picker-box {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 5px;
  }
  ::v-deep .el-input__inner{
    border:none !important;
    
  }
  .el-date-editor{
    width: 120px !important;
  }
  ::v-deep .el-input__prefix{
    display: none !important;
  }
  .el-icon-date{
    margin-left: 20px;
  }
  </style>
  